// extracted by mini-css-extract-plugin
export var text = "_31-0";